import axios from 'axios'
import { Notification } from 'element-ui'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // 超时
  timeout: 10000
})

// 响应拦截器
service.interceptors.response.use(res => {
    const code = res.data.code
    if (code >= 0) {
      return res.data
    }

    if (code === -1) {
      Notification.error({
        title: '系统错误:' + (res.data.errMsg || '')
      })
      return res.data
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
